import { mapMarkerIcon } from '@/modules/globals'

/**
 * Mixin with reusable methods in every map
 */
export default {
  data () {
    return {
      googleMap: null,
      infoWindow: null,
      mapWrapper: null,
      selectedAirport: 'Wszystkie lotniska wylotu',
    }
  },

  methods: {
    /**
     * 
     * @param {Object} json data from server
     */
    getCenterCoords (json) {
      return {
        lat: parseFloat(json.latitude),
        lng: parseFloat(json.longitude),
      }
    },

    getMarker (position, map, markerIcon, label) {
      markerIcon = markerIcon || mapMarkerIcon.regionActive

      return new google.maps.Marker({
        position,
        map,
        icon: markerIcon,
        label,
      })
    },

    /**
     * 
     * @param {Object} marker can be GoogleMaps marker object and also object with data from SC
     */
    setMarkerLatPosition (marker) {
      if (marker.hasOwnProperty('map')) {
        return parseFloat(marker.getPosition().lat()).toFixed(6)
      } else {
        return parseFloat(marker.Latitude).toFixed(6)
      }
    },

    /**
     * 
     * @param {Object} marker can be GoogleMaps marker object and also object with data from SC
     */
    setMarkerLngPosition (marker) {    
      if (marker.hasOwnProperty('map')) {
        return parseFloat(marker.getPosition().lng()).toFixed(6) 
      } else {
        return parseFloat(marker.Longitude).toFixed(6)
      }
    }, 

    loadCustomMapStyles (styles) {
      /** Json comes from sitecore textarea field, so we need to remove unnecessary chars **/
      const clearJsonString = styles.replace(/<br \/>|&nbsp;|;| /gi, '')
      return JSON.parse(clearJsonString)
    },

    setNewMarkerPosition (lat, lng) {
      return new google.maps.LatLng(lat, lng)
    },

    setNewMap (root, options) {
      return new google.maps.Map(root, options)
    },

    /**
     * 
     * @param {Array} markers 
     * @param {String} icon path to icon
     */
    setMapMarkersIcon (markers, markerIcon) {
      const icon = markerIcon || mapMarkerIcon.regionActive
      markers.forEach(item => item.setIcon(icon))
    },
    
    /**
     * 
     * @param {Object} map google maps instance
     * @param {Object} json map data 
     */
    setDefaultMapPosition (map, json) {
      map.setCenter({
        lat: parseFloat(json.latitude),
        lng: parseFloat(json.longitude),
      })
      map.setZoom(parseInt(json.zoom))
    },

    zoomMapIn (map) {
      map.setZoom(map.getZoom() + 1)
    },

    zoomMapOut (map) {
      map.setZoom(map.getZoom() - 1)
    },

    fullScreenMap () {
      this.mapWrapper.parentElement.classList.add('fullscreen')
      
      /**
       * @todo after full search rewrite please, use BoodyFreezerMixin.js instead
       * of this part of code
       */
      document.documentElement.classList.add('body-freeze')
      document.documentElement.scrollTop = 0
    },

    exitFullScreenMap () {
      this.mapWrapper.parentElement.classList.remove('fullscreen')
      
      /**
       * @todo after full search rewrite please, use BoodyFreezerMixin.js instead
       * of this part of code
       */
      document.documentElement.classList.remove('body-freeze')
    },

    initMarkerClusterer (markers) {
      const markerClusterer = new MarkerClusterer(this.googleMap, markers, {
        zoomOnClick: true,
        gridSize: 20,
        maxZoom: 20,
        styles: [ {
          url: '/assets/images/Maps/Salesmap/others/clusters/cluster1.png',
          height: 26,
          width: 26,
          iconAnchor: [ 12, 12 ],
        } ],
      })

      /**
       * Clusterer will add by default index number as string into the cluster on map
       * and for us its unnecessary because we using custom PNG.
       */
      markerClusterer.setCalculator(() => ({
        text: ' ',
        index: 0,
      }))
    },
  },
}


// WEBPACK FOOTER //
// ./src/components/GoogleMapsMixin.js